import { createAsyncThunk } from '@reduxjs/toolkit';
import apiFetch from 'services/apiFetch';
import { createRequirement } from 'services/checklistEndPoints';
import { ICreateRequirement } from 'interfaces/requirements.interface';

export const createChecklistRequirement = createAsyncThunk(
  'checklist/createRequirement',
  async (data: ICreateRequirement) => {
    try {
      const endpoint = createRequirement(data);
      return await apiFetch<Partial<ICreateRequirement>>(endpoint).then((res) => res?.data || null);
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('Create Requirement catch:', message);
      throw Error(message);
    }
  }
);
